import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _extends from '@babel/runtime/helpers/esm/extends';
import React, { forwardRef, useRef, useState, useEffect } from 'react';
import { useTheme } from '@paypalcorp/pp-react-theme';
import { SelectionMenu } from '@paypalcorp/pp-react-selection-menu';
import clsx from 'clsx';
import { V2CriticalIcon, CriticalAltIcon, ChevronUpAltIcon, ChevronDownAltIcon, V2ChevronUpIcon, V2ChevronDownIcon } from '@paypalcorp/pp-react-icons';
import '../__generated__/styles/dropdown-menu.css';

var styles = {"ppvx_dropdown-menu":"ppvx_dropdown-menu___1-9-26","ppvx_dropdown-menu__label":"ppvx_dropdown-menu__label___1-9-26","ppvx_dropdown-menu__button":"ppvx_dropdown-menu__button___1-9-26","ppvx_dropdown-menu__affordance-icon":"ppvx_dropdown-menu__affordance-icon___1-9-26","ppvx_dropdown-menu__label--empty":"ppvx_dropdown-menu__label--empty___1-9-26","ppvx_dropdown-menu__button--active":"ppvx_dropdown-menu__button--active___1-9-26","ppvx_dropdown-menu__helper-text":"ppvx_dropdown-menu__helper-text___1-9-26","ppvx_dropdown-menu__error-text":"ppvx_dropdown-menu__error-text___1-9-26","ppvx_dropdown-menu__error-icon":"ppvx_dropdown-menu__error-icon___1-9-26","ppvx_field--error":"ppvx_field--error___1-9-26","ppvx_dropdown-menu--combine-right":"ppvx_dropdown-menu--combine-right___1-9-26","ppvx_dropdown-menu--combine-left":"ppvx_dropdown-menu--combine-left___1-9-26","ppvx_dropdown-menu--combine-both":"ppvx_dropdown-menu--combine-both___1-9-26","ppvx_dropdown-menu__button-with-svg-icon":"ppvx_dropdown-menu__button-with-svg-icon___1-9-26","ppvx_dropdown-menu__error-text-with-svg-icon":"ppvx_dropdown-menu__error-text-with-svg-icon___1-9-26","ppvx--v2":"ppvx--v2___1-9-26","ppvx--v1":"ppvx--v1___1-9-26","ppvx_dropdown-menu__select":"ppvx_dropdown-menu__select___1-9-26"};

var _excluded = ["className", "menuContainerClassName", "menuListClassName", "menuItemClassName", "menuMobileHeaderClassName", "menuButtonClassName", "menuLabelClassName", "skipButtonFocus", "sheetClassName", "sheetWrapperClassName", "id", "label", "name", "errorText", "errorIconAriaLabel", "helperText", "selectedItemIndex", "value", "options", "ariaLabelledby", "removeBorderRadiusRight", "removeBorderRadiusLeft", "removeBorderRadiusBoth", "renderButtonContent", "onSelection", "onChange", "onClose", "onClick", "onKeyDown", "theme", "isLoadingOptions"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getRefCurrent = function (ref) {
  return (
    /* istanbul ignore next */
    ref && ref.current ? ref.current : null
  );
}; // Get either the error message or helper text or... nothing


var renderMessage = function (errorText, errorIconAriaLabel, helperText, msgId, theme) {
  if (errorText) {
    var errorProps = {
      className: styles['ppvx_dropdown-menu__error-icon'],
      role: 'img',
      'aria-label': errorIconAriaLabel
    };
    var dropdownErrorIcon = theme === 'v2' ? /*#__PURE__*/React.createElement(V2CriticalIcon, _extends({
      size: "sm"
    }, errorProps)) : /*#__PURE__*/React.createElement(CriticalAltIcon, _extends({
      size: "xs"
    }, errorProps));
    var errorClasses = clsx(styles['ppvx_dropdown-menu__error-text'], styles['ppvx_dropdown-menu__error-text-with-svg-icon']);
    return /*#__PURE__*/React.createElement("div", {
      className: errorClasses,
      id: msgId
    }, dropdownErrorIcon, /*#__PURE__*/React.createElement("span", null, errorText));
  }

  if (helperText) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles['ppvx_dropdown-menu__helper-text'],
      id: msgId
    }, /*#__PURE__*/React.createElement("span", null, helperText));
  }

  return null;
};

var hasNoModifiers = function (evt) {
  return !evt.altKey && !evt.ctrlKey && !evt.shiftKey && !evt.metaKey;
};

var DropdownMenu = forwardRef( // eslint-disable-next-line complexity
function (props, ref) {
  var _clsx;

  var className = props.className,
      menuContainerClassName = props.menuContainerClassName,
      menuListClassName = props.menuListClassName,
      menuItemClassName = props.menuItemClassName,
      menuMobileHeaderClassName = props.menuMobileHeaderClassName,
      menuButtonClassName = props.menuButtonClassName,
      menuLabelClassName = props.menuLabelClassName,
      _props$skipButtonFocu = props.skipButtonFocus,
      skipButtonFocus = _props$skipButtonFocu === void 0 ? false : _props$skipButtonFocu,
      sheetClassName = props.sheetClassName,
      sheetWrapperClassName = props.sheetWrapperClassName,
      id = props.id,
      label = props.label,
      name = props.name,
      errorText = props.errorText,
      _props$errorIconAriaL = props.errorIconAriaLabel,
      errorIconAriaLabel = _props$errorIconAriaL === void 0 ? 'Error' : _props$errorIconAriaL,
      helperText = props.helperText,
      selectedItemIndex = props.selectedItemIndex,
      value = props.value,
      options = props.options,
      ariaLabelledby = props.ariaLabelledby,
      removeBorderRadiusRight = props.removeBorderRadiusRight,
      removeBorderRadiusLeft = props.removeBorderRadiusLeft,
      removeBorderRadiusBoth = props.removeBorderRadiusBoth,
      renderButtonContent = props.renderButtonContent,
      onSelection = props.onSelection,
      onChange = props.onChange,
      onClose = props.onClose,
      onClick = props.onClick,
      onKeyDown = props.onKeyDown,
      theme = props.theme,
      isLoadingOptions = props.isLoadingOptions,
      rest = _objectWithoutProperties(props, _excluded);

  var _theme = useTheme('DropdownMenu', theme);

  var isThemeV2 = _theme && _theme === 'v2';

  if (_theme !== 'v2') {
    console.warn('Dropdown Menus 1.0 styles are deprecated. Use Dropdown Menus 2.0 styles and refer to our Migration Guide on how to use 2.0 styles/components.');
  }

  var buttonId = id ? "dropdownMenuButton_".concat(id) : "dropdownMenuButton_".concat(label.replace(/\s/g, ''));
  var internalRef = useRef();
  var buttonRef = ref || internalRef;
  var selectId = id ? "dropdownMenuSelect_".concat(id) : "dropdownMenuSelect_".concat(label.replace(/\s/g, ''));

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showMenu = _useState2[0],
      setShowMenu = _useState2[1];

  var _useState3 = useState(!!value),
      _useState4 = _slicedToArray(_useState3, 2),
      initialItemFocus = _useState4[0],
      setKeyboardActive = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isRtl = _useState6[0],
      setRtl = _useState6[1];

  useEffect(function () {
    var btn = getRefCurrent(buttonRef);
    var computedStyle = window && window.getComputedStyle(btn);
    setRtl(computedStyle && computedStyle.direction === 'rtl');
  });
  var dropdownMenuClass = clsx(styles['ppvx_dropdown-menu'], (_clsx = {}, _defineProperty(_clsx, styles['ppvx--v2'], isThemeV2), _defineProperty(_clsx, styles['ppvx_field--error'], errorText), _defineProperty(_clsx, styles['ppvx_dropdown-menu--combine-right'], removeBorderRadiusRight), _defineProperty(_clsx, styles['ppvx_dropdown-menu--combine-left'], removeBorderRadiusLeft), _defineProperty(_clsx, styles['ppvx_dropdown-menu--combine-both'], removeBorderRadiusBoth), _clsx), className);
  var buttonClass = clsx(styles['ppvx_dropdown-menu__button'], styles['ppvx_dropdown-menu__button-with-svg-icon'], showMenu && styles['ppvx_dropdown-menu__button--active'], menuButtonClassName);

  var openMenu = function (evt) {
    setShowMenu(function (prevState) {
      return !prevState;
    });
    setKeyboardActive(!evt.detail);
  };

  var handleItemClick = function (index) {
    setShowMenu(false);
    var buttonCurrent = getRefCurrent(buttonRef);
    /* istanbul ignore next */

    if (buttonCurrent) {
      if (skipButtonFocus) {
        buttonCurrent.blur();
      } else {
        buttonCurrent.focus();
      }
    }
    /* istanbul ignore else */


    if (onSelection) {
      onSelection(index);
    }
    /* istanbul ignore next */


    if (onChange) {
      /* istanbul ignore next */
      var selectedValue = options && options.length > 0 && index >= 0 ? options[index].value || options[index].primaryText : null;
      onChange({
        target: {
          selectedIndex: index,
          value: selectedValue
        }
      });
    }
  };

  var msgId = helperText && 'dropdown_helperText' || errorText && 'dropdown_errorText';
  var buttonText = '';
  var buttonValue = '';
  var selectedIndex = -1;

  if (value) {
    for (var i = 0; i < options.length; i++) {
      if (options[i].value === value) {
        if (renderButtonContent) {
          buttonText = renderButtonContent();
        } else {
          buttonText = options[i].primaryText;
        }

        buttonValue = options[i].value;
        selectedIndex = i;
        break;
      }
    }
  } else if (selectedItemIndex >= 0 && selectedItemIndex < options.length) {
    buttonValue = options[selectedItemIndex].primaryText;
    selectedIndex = selectedItemIndex;

    if (renderButtonContent) {
      buttonText = renderButtonContent();
    } else {
      buttonText = options[selectedItemIndex].primaryText;
    }
  }

  var V1AffordanceIcon = showMenu ? ChevronUpAltIcon : ChevronDownAltIcon;
  var V2AffordanceIcon = showMenu ? V2ChevronUpIcon : V2ChevronDownIcon;
  var affordanceClass = styles['ppvx_dropdown-menu__affordance-icon'];
  var AffordanceIcon = isThemeV2 ? /*#__PURE__*/React.createElement(V2AffordanceIcon, {
    size: "sm",
    className: affordanceClass,
    "aria-hidden": "true"
  }) : /*#__PURE__*/React.createElement(V1AffordanceIcon, {
    size: "xs",
    className: affordanceClass,
    "aria-hidden": "true"
  });
  var labelClasses = clsx(styles['ppvx_dropdown-menu__label'], !buttonText && styles['ppvx_dropdown-menu__label--empty'], menuLabelClassName);
  var labelledBy = ariaLabelledby ? "".concat(buttonId, "-label ").concat(ariaLabelledby) : "".concat(buttonId, "-label");

  if (buttonText) {
    labelledBy = "".concat(labelledBy, " ").concat(buttonId);
  }

  var otherButtonAttr = _objectSpread(_objectSpread(_objectSpread({}, msgId && {
    'aria-describedby': msgId
  }), {
    'aria-labelledby': labelledBy
  }), rest);

  return /*#__PURE__*/React.createElement("div", {
    className: dropdownMenuClass,
    id: id
  }, /*#__PURE__*/React.createElement("select", {
    "aria-hidden": "true",
    id: selectId,
    name: name,
    className: styles['ppvx_dropdown-menu__select'],
    tabIndex: -1,
    onChange: function (evt) {
      return handleItemClick(evt.target.selectedIndex - 1);
    },
    value: buttonValue
  }, /*#__PURE__*/React.createElement("option", {
    disabled: true,
    value: ""
  }, label), options && options.length > 0 && options.map(function (opt, index) {
    return /*#__PURE__*/React.createElement("option", {
      key: index,
      value: opt.value ? opt.value : opt.primaryText
    }, opt.primaryText);
  })), /*#__PURE__*/React.createElement("button", _extends({
    className: buttonClass,
    type: "button",
    id: buttonId,
    ref: buttonRef,
    "aria-haspopup": "listbox",
    "aria-expanded": showMenu,
    onClick: function handleClick(evt) {
      openMenu(evt);
      /* istanbul ignore next */

      if (onClick) {
        onClick(evt);
      }
    },
    onKeyDown: function handleKey(evt) {
      /* istanbul ignore next */
      if (!showMenu && (evt.key === 'Up' || evt.key === 'Down' || evt.key === 'ArrowUp' || evt.key === 'ArrowDown') && hasNoModifiers(evt)) {
        evt.preventDefault();
        openMenu(evt);
      }
      /* istanbul ignore next */


      if (onKeyDown) {
        onKeyDown(evt);
      }
    }
  }, otherButtonAttr), AffordanceIcon, /*#__PURE__*/React.createElement("span", null, buttonText)), /*#__PURE__*/React.createElement("label", {
    id: "".concat(buttonId, "-label"),
    htmlFor: buttonId,
    className: labelClasses
  }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement(SelectionMenu, {
    initialItemFocus: initialItemFocus,
    isOpen: showMenu,
    mobileTitle: label,
    onClose: function handleClose(evt) {
      setShowMenu(false);

      if (onClose) {
        onClose(evt);
      }
    },
    onSelection: handleItemClick,
    selectedIndex: selectedIndex,
    triggerElementId: buttonId,
    options: options,
    className: menuListClassName,
    containerClassName: menuContainerClassName,
    itemClassName: menuItemClassName,
    mobileHeaderClassName: menuMobileHeaderClassName,
    sheetClassName: sheetClassName,
    sheetWrapperClassName: sheetWrapperClassName,
    rtl: isRtl,
    returnFocusToTrigger: !skipButtonFocus,
    theme: _theme,
    isLoadingOptions: isLoadingOptions,
    searchEnabled: true
  }), renderMessage(errorText, errorIconAriaLabel, helperText, msgId, _theme));
});

export { DropdownMenu };
